export const DAILY_CHECKIN_CONTRACT_ADDRESS =
  'EQC_0ScHnb7bVoyInXLkZ2G4XRHg97S9XrPKCUDaO1ZRyFhZ';
export const DAILY_CHECKIN_CONTRACT_TRANSFER_VALUE = '0.008';
export const DAILY_CHECKIN_CONTRACT_TX_VALID = 5 * 60 * 1000;
export const ONE_DAY_MS = 86400 * 1000;
export const DAILY_CHECKIN_CONTRACT_REWARD = 25000;
export const DAILY_CHECKIN_CONTRACT_LABEL = 'Gemz Checkin';
